import { render, staticRenderFns } from "./DealSheetDetailTable.vue?vue&type=template&id=489cb62e&scoped=true"
import script from "./DealSheetDetailTable.vue?vue&type=script&lang=js"
export * from "./DealSheetDetailTable.vue?vue&type=script&lang=js"
import style0 from "./DealSheetDetailTable.vue?vue&type=style&index=0&id=489cb62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cb62e",
  null
  
)

export default component.exports